import { render } from "./AddGlobalNote.vue?vue&type=template&id=4a7d3b6c&ts=true"
import script from "./AddGlobalNote.vue?vue&type=script&lang=ts"
export * from "./AddGlobalNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__